import React from "react";
import "./MedicalTourism1.css";

const missionData = [
  {
    icon: "/assets/mission1.svg",
    title: "Extensive Medical Network",
    description:
      "Access to 100+ accredited hospitals and specialists across India.",
  },
  {
    icon: "/assets/mission2.svg",
    title: "Free Preliminary Consultation",
    description:
      "A no-cost second opinion from our specialist panel before you decide.",
  },
  {
    icon: "/assets/mission3.svg",
    title: "Ethical Healthcare",
    description:
      "Unbiased hospital matching based on medical need, not commission.",
  },
  {
    icon: "/assets/mission4.svg",
    title: "End-to-End Patient Care",
    description:
      "One point of contact from visa to discharge and everything in between.",
  },
  {
    icon: "/assets/mission5.svg",
    title: "Recovery & Wellness",
    description:
      "Curated post-treatment stays for rest before the journey home.",
  },
  {
    icon: "/assets/mission6.svg",
    title: "Flexible Treatment Plans",
    description:
      "Options shaped around your budget, timeline, and comfort.",
  },
];

const MedicalTourism1 = () => {
  return (
    <section className="mission standard-padding">

      <div className="mission-header">
        <p className="subheading">Our Mission</p>

        <h1 className="heading mission-heading">
          Making world-class healthcare reachable
        </h1>
      </div>

      <div className="mission-grid">
        {missionData.map((item, index) => (
          <div className="mission-card" key={index}>

            <div className="mission-icon">
              <img src={item.icon} alt={item.title} />
            </div>

            <h3>{item.title}</h3>

            <p>{item.description}</p>

          </div>
        ))}
      </div>

    </section>
  );
};

export default MedicalTourism1;